import { SequenceItem, useEditorStore } from '~/shell/Store';

const BLANK = 'XXX';

/**
 * The blanks in a fill-in-the-blank body as the server counts them: every
 * XXX it holds, overlapping ones too, in the body as sent (markup and all).
 */
export const blankCount = (body: string) => {
  let count = 0;
  for (
    let at = body.indexOf(BLANK);
    at !== -1;
    at = body.indexOf(BLANK, at + 1)
  ) {
    count += 1;
  }
  return count;
};

const plural = (count: number, word: string) =>
  `${count} ${count === 1 ? word : `${word}s`}`;

/**
 * Why the server would refuse this body for a question with this many correct
 * answers, or null: it takes a present body with one XXX for each.
 */
export const sentenceProblem = (
  body: string,
  correctAnswers: number
): string | null => {
  if (!body.trim()) {
    return 'Write the sentence, with XXX where each blank goes.';
  }
  const blanks = blankCount(body);
  if (blanks !== correctAnswers) {
    return `This sentence has ${plural(blanks, 'blank')} but ${plural(
      correctAnswers,
      'correct answer'
    )}. Use one XXX for each correct answer.`;
  }
  return null;
};

const findItem = (
  items: SequenceItem[] | undefined,
  id: string
): SequenceItem | undefined => {
  for (const item of items || []) {
    if (String(item.id) === id) return item;
    const found = findItem(item.items, id);
    if (found) return found;
  }
  return undefined;
};

/** How many of a question's answers are correct, in the editor's copy. */
export const correctAnswersOf = (questionId: string) =>
  (
    findItem(useEditorStore.getState().sequence?.items, questionId)?.items ?? []
  ).filter(answer => answer.correct).length;
